import { render, staticRenderFns } from "./tenant__form.vue?vue&type=template&id=1506c9a6"
import script from "./tenant__form.vue?vue&type=script&lang=js"
export * from "./tenant__form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports